var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenericError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "generic-error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-19.4%",
    y: "-600.0%",
    width: "138.7%",
    height: "1300.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "generic-error",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(62.000000, 46.000000) rotate(-10.000000) translate(-62.000000, -46.000000) translate(34.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1879998,7.90522315 L55.1879998,83.5052229 L0,83.5052229 L0,7.90522315 L55.1879998,7.90522315 Z M52.9199998,10.1732231 L2.26799999,10.1732231 L2.26799999,81.2372229 L52.9199998,81.2372229 L52.9199998,10.1732231 Z",
    id: "background",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6834035,-2.66453526e-14 C29.6163662,-2.66453526e-14 31.1833421,1.56697587 31.1833421,3.49993857 C31.1833421,4.35621748 30.8713335,5.1614952 30.3353213,5.78406293 L40.204487,5.78310651 L40.204487,12.4625614 L15.1623201,12.4625614 L15.1623201,5.78310651 L25.0317145,5.78432993 C24.1739173,4.78919149 23.9415078,3.38789373 24.4498819,2.16057006 C24.9916059,0.852732655 26.2678105,-2.66453526e-14 27.6834035,-2.66453526e-14 Z M27.6834108,1.47992543 C26.568768,1.48130938 25.6659013,2.38529284 25.6659013,3.4999365 C25.6659013,4.61458017 26.5687607,5.51856687 27.6834035,5.51995323 L27.6834035,5.51995323 C28.2193618,5.51435274 28.7336145,5.30199603 29.1129469,4.92336873 C29.4922793,4.54474144 29.7055924,4.03088468 29.7059244,3.49492612 C29.7031577,2.38028589 28.7980536,1.47854465 27.6834108,1.47992543 Z",
    id: "themed",
    fill: "#534776",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "themed",
    fill: "#534776",
    filter: "url(#filter-1)",
    cx: 64,
    cy: 129,
    rx: 62,
    ry: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericError);
export default __webpack_public_path__ + "static/media/generic-error.91b60fd62bddca5c3bae4253bba3419d.svg";
export { ForwardRef as ReactComponent };